import { render, staticRenderFns } from "./Screenfull.vue?vue&type=template&id=c6a6598a&scoped=true"
import script from "./Screenfull.vue?vue&type=script&lang=js"
export * from "./Screenfull.vue?vue&type=script&lang=js"
import style0 from "./Screenfull.vue?vue&type=style&index=0&id=c6a6598a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_cache-loader@4.1.0_webpack@4.47.0__css-load_857a25aa4406afef410ce4b662efafed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a6598a",
  null
  
)

export default component.exports